// extracted by mini-css-extract-plugin
module.exports = {"back_prev":"PreviousButton_back_prev__4glwb","prev_icon":"PreviousButton_prev_icon__gr1Gp"};